
import React from 'react';
import { ComponentNode } from '../types/template';
import { convertStylesToInline, getColumnClasses, getCustomThemeColumnFlexStyle } from '../utils/styleUtils';
import ComponentRenderer from './ComponentRenderer';

interface ColumnComponentProps {
    component: ComponentNode;
    data?: any;
    context?: any;
}

const ColumnComponent: React.FC<ColumnComponentProps> = ({ component, data, context }) => {
    const { styles, components, size, customClassName } = component;
    const inlineStyles = convertStylesToInline(styles);
    const colClasses = getColumnClasses(size);
    const responsiveStyles: React.CSSProperties = {
        ...inlineStyles,
        ...getCustomThemeColumnFlexStyle(size),
    };

    return (
        <div
            style={responsiveStyles}
            className={['cb-responsive-column', colClasses, customClassName].filter(Boolean).join(' ')}
        >
            {components?.map((child) => (
                <ComponentRenderer key={child.id} component={child} data={data} context={context} />
            ))}
        </div>
    );
};

export default ColumnComponent;
